import { render } from "./AlertList.component.vue?vue&type=template&id=5527a39a&scoped=true&ts=true"
import script from "./AlertList.component.vue?vue&type=script&lang=ts"
export * from "./AlertList.component.vue?vue&type=script&lang=ts"

import "./AlertList.component.vue?vue&type=style&index=0&id=5527a39a&lang=scss&scoped=true"
import "./AlertList.component.vue?vue&type=style&index=1&id=5527a39a&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5527a39a"]])

export default __exports__